// Load a video fully into memory and serve it from a blob: URL.
// This makes video.currentTime seeking (scroll scrubbing) work in ALL browsers
// even when the host (e.g. Cloudflare Pages) does not support HTTP range/206
// requests — Chrome refuses to seek on non-range-served media otherwise.
export async function attachBlobVideo(video, sources) {
  if (!video) return null;
  const pick = sources.find((s) => video.canPlayType(s.type)) || sources[0];
  try {
    const res = await fetch(pick.src);
    if (!res.ok) throw new Error(`fetch ${pick.src} ${res.status}`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    video.src = url;
    video.load();
    return url;
  } catch (e) {
    // Fallback: point straight at the file so at least something plays.
    video.src = pick.src;
    video.load();
    return null;
  }
}
